import { useState, useEffect } from 'react'
import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { styled, Theme, useTheme } from '@mui/material/styles'
import { Dialog, Grid, Typography, Button, useMediaQuery } from '@mui/material'
import CoreHeader from './CoreHeader'
import CoreFooter from './CoreFooter'
import Textbox from '../../control/Textbox'
import DialogControl from '../../control/Dialog'
import Scrollbar from '../../control/Scrollbar'
import useProfile, { Form, validate } from '../../hooks/map/useProfile'
import { ReactComponent as ContactIcon } from '../../icon/profile_contact.svg'
import { ReactComponent as SecurityIcon } from '../../icon/profile_security.svg'
import { useSelector } from 'react-redux'
import { RootStateType } from '../../redux/reducer/rootReducer'

const BgImage = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/bg_white.png`

type FormProfileProps = {}

const FormProfile = (props: FormProfileProps) => {
    const {
        openDialogError,
        openDialogLogout,
        openDialogBack,
        openDialogSave,
        openDialogOk,
        alertMessageOk,
        alertMessageError,
        onClickOk,
        onClickBack,
        onClickCancelBack,
        onClickConfirmBack,
        onClickCancelSave,
        onClickConfirmSave,
        onClickConfirmLogout,
        onClickCancelLogout,
        onSubmitForm,
        onClickLogout,
        onClickChangeISYL,
        callServiceGetProfile,
    } = useProfile()
    const { t } = useTranslation()
    const classes = useStyles()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))
    const { isLoggedIn } = useSelector(({ profile }: RootStateType) => profile)

    const validates = (values: Form) => {
        const validation = validate(values, t) || {}
        return validation
    }

    const [openDialog, setOpenDialog] = useState(true)
    const [initialValues, setInitialValues] = useState<Form>({
        username: '',
        email: '',
        firstname: '',
        lastname: '',
        department: '',
    })

    useEffect(() => {
        if (isLoggedIn) {
            callServiceGetInitial()
        }
    }, [isLoggedIn])

    const callServiceGetInitial = async () => {
        const { result } = await callServiceGetProfile()

        if (result?.data) {
            setInitialValues({
                username: result?.data.username,
                email: result?.data.email,
                firstname: result?.data.name,
                lastname: result?.data.surname,
                department: result?.data.department,
            })
        }
    }

    return (
        <>
            <Dialog
                fullScreen
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false)
                }}
                classes={{ paper: classes.drawerPaper }}
            >
                <CoreHeader />

                <StyledContent>
                    <div style={{ width: '100%', height: '100%' }}>
                        <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                            <StyledContainer>
                                <FinalForm onSubmit={onSubmitForm} validate={validates} initialValues={initialValues}>
                                    {({ handleSubmit, dirty }) => (
                                        <form onSubmit={handleSubmit}>
                                            <div>
                                                <StyledDivSectionTitle>
                                                    <IconContact />
                                                    <StyledTypoSectionTitle>
                                                        {t('LABEL.PROFILE.USER')}
                                                    </StyledTypoSectionTitle>
                                                </StyledDivSectionTitle>
                                                <StyledDivSectionContent>
                                                    <Grid container spacing={2} className={classes.container}>
                                                        <Grid item xs={12} md={6}>
                                                            <Field
                                                                name="username"
                                                                label={t('LABEL.PROFILE.USERNAME')}
                                                                placeholder={t('LABEL.PROFILE.USERNAME')}
                                                                component={Textbox}
                                                                fullWidth
                                                                disabled
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Field
                                                                name="email"
                                                                label={t('LABEL.PROFILE.EMAIL')}
                                                                placeholder={t('LABEL.PROFILE.EMAIL')}
                                                                component={Textbox}
                                                                fullWidth
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Field
                                                                name="firstname"
                                                                label={t('LABEL.PROFILE.FIRST_NAME')}
                                                                placeholder={t('LABEL.PROFILE.FIRST_NAME')}
                                                                component={Textbox}
                                                                fullWidth
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Field
                                                                name="lastname"
                                                                label={t('LABEL.PROFILE.LAST_NAME')}
                                                                placeholder={t('LABEL.PROFILE.LAST_NAME')}
                                                                component={Textbox}
                                                                fullWidth
                                                                required
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Field
                                                                name="department"
                                                                label={t('LABEL.PROFILE.ORGANIZATION')}
                                                                placeholder={t('LABEL.PROFILE.ORGANIZATION')}
                                                                component={Textbox}
                                                                fullWidth
                                                                disabled
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </StyledDivSectionContent>
                                            </div>
                                            <div style={{ marginTop: '30px' }}>
                                                <StyledDivSectionTitle>
                                                    <IconSecurity />
                                                    <StyledTypoSectionTitle>
                                                        {t('LABEL.PROFILE.SECURITY')}
                                                    </StyledTypoSectionTitle>
                                                </StyledDivSectionTitle>
                                                <StyledDivSectionContent>
                                                    <div>
                                                        <Typography>
                                                            {
                                                                'การเปลี่ยนรหัสผ่านบ่อย ๆ จะช่วยเพิ่มความปลอดภัยของข้อมูลของคุณ'
                                                            }
                                                        </Typography>
                                                    </div>
                                                    <div style={{ marginTop: '20px' }}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={onClickChangeISYL}
                                                            classes={{ root: classes.buttonChangePassword }}
                                                        >
                                                            {t('BUTTON.CHANGE_PASSWORD')}
                                                        </Button>
                                                    </div>
                                                </StyledDivSectionContent>
                                            </div>
                                            {isMobileView ? (
                                                <StyledDivButton>
                                                    <Grid container spacing={2} className={classes.container}>
                                                        <Grid item xs={12}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                type="submit"
                                                                classes={{ root: classes.button }}
                                                            >
                                                                {t('BUTTON.SAVE_DATA')}
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                onClick={() => {
                                                                    onClickBack(dirty)
                                                                }}
                                                                classes={{ root: classes.button }}
                                                            >
                                                                {t('BUTTON.CANCEL')}
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                onClick={onClickLogout}
                                                                classes={{ root: classes.buttonLogout }}
                                                            >
                                                                {t('BUTTON.LOG_OUT')}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </StyledDivButton>
                                            ) : (
                                                <StyledDivButton>
                                                    <Grid container spacing={2} className={classes.container}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                onClick={onClickLogout}
                                                                classes={{ root: classes.buttonLogout }}
                                                            >
                                                                {t('BUTTON.LOG_OUT')}
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} className={classes.divButtonGroup}>
                                                            <div className={classes.divButton}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        onClickBack(dirty)
                                                                    }}
                                                                    classes={{ root: classes.button }}
                                                                >
                                                                    {t('BUTTON.CANCEL')}
                                                                </Button>
                                                            </div>
                                                            <div className={classes.divButton}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    type="submit"
                                                                    classes={{ root: classes.button }}
                                                                >
                                                                    {t('BUTTON.SAVE_DATA')}
                                                                </Button>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </StyledDivButton>
                                            )}
                                        </form>
                                    )}
                                </FinalForm>
                            </StyledContainer>
                        </Scrollbar>
                    </div>
                </StyledContent>

                <StyledFooter>
                    <CoreFooter />
                </StyledFooter>
            </Dialog>
            <DialogControl
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={t('ALERT.CONTENT.DISCARD_CHANGE')}
                isOpen={openDialogBack ? true : false}
                onClickCancel={onClickConfirmBack}
                onClickConfirm={onClickCancelBack}
                labelButtonCancel={t('BUTTON.LEAVE')}
                labelButtonConfirm={t('BUTTON.STAY')}
                disableClickBackdrop
                hideCloseButton
            />
            <DialogControl
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={'ยืนยันบันทึกข้อมูล'}
                isOpen={openDialogSave}
                onClickConfirm={onClickConfirmSave}
                onClickCancel={onClickCancelSave}
                labelButtonCancel={t('BUTTON.CANCEL')}
                labelButtonConfirm={t('BUTTON.CONFIRM')}
                disableClickBackdrop
                hideCloseButton
            />
            <DialogControl
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={'ต้องการออกจากระบบหรือไม่'}
                isOpen={openDialogLogout}
                onClickConfirm={onClickConfirmLogout}
                onClickCancel={onClickCancelLogout}
                labelButtonCancel={t('BUTTON.CANCEL')}
                labelButtonConfirm={t('BUTTON.LOG_OUT')}
                disableClickBackdrop
                hideCloseButton
            />
            <DialogControl
                type="ok"
                title={t('ALERT.TITLE.NOTIFY')}
                content={alertMessageOk}
                isOpen={openDialogOk}
                onClickOk={onClickOk}
                labelButtonOk={t('BUTTON.OK')}
                disableClickBackdrop
                hideCloseButton
            />
            <DialogControl
                type="ok"
                severity="error"
                title={t('ALERT.TITLE.ERROR')}
                content={alertMessageError}
                isOpen={openDialogError}
                onClickOk={onClickOk}
                labelButtonOk={t('BUTTON.OK')}
                disableClickBackdrop
                hideCloseButton
            />
        </>
    )
}

export default FormProfile

const useStyles = makeStyles((theme: Theme) => ({
    drawerPaper: {
        backgroundImage: `url(${BgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    divButtonGroup: {
        display: 'flex',
        justifyContent: 'end',
        paddingBottom: '15px',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            justifyContent: 'flex-start',
        },
    },
    divButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            margin: 0,
            marginBottom: theme.spacing(2),
            justifyContent: 'flex-start',
        },
    },
    buttonChangePassword: {
        width: '155px',
        minHeight: '37px',
        fontSize: '14px !important',
        [theme.breakpoints.down('sm')]: {
            width: '125px',
        },
    },
    buttonLogout: {
        width: '125px',
        minHeight: '37px',
        fontSize: '14px !important',
        backgroundColor: `${theme.palette.getContrastText('fail')} !important`,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    button: {
        width: '125px',
        minHeight: '37px',
        fontSize: '14px !important',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}))

const StyledContent = styled('div')(({ theme }) => ({
    height: `calc(100% - 92px)`,
}))

const StyledContainer = styled('div')(({ theme }) => ({
    margin: '30px 100px',
    padding: '30px',
    borderRadius: '5px',
    backgroundColor: '#FAFAFA',
    boxShadow: theme.palette.getContrastText('shadow-box'),
    [theme.breakpoints.down('sm')]: {
        margin: '30px 20px',
    },
}))

const StyledDivSectionTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
}))

const StyledFooter = styled('div')(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    width: '100%',
}))

const StyledTypoSectionTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.dark,
    fontWeight: 'bold',
    fontSize: '20px',
}))

const StyledDivSectionContent = styled('div')(({ theme }) => ({
    border: `1px solid ${theme.palette.text.disabled}`,
    borderRadius: '5px',
    padding: '20px 40px',
}))

const StyledDivButton = styled('div')(({ theme }) => ({
    marginTop: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}))

const IconContact = styled(ContactIcon)(({ theme }) => ({
    height: '18px',
    marginRight: theme.spacing(1.5),
}))

const IconSecurity = styled(SecurityIcon)(({ theme }) => ({
    height: '18px',
    marginRight: theme.spacing(1.5),
}))
